import React, { useState } from 'react'
import { DataTable, DataTableRow, Divider, Expander, ExpanderContent, ExpanderHeader, H5 } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function OdmRecordProxy({ proxies }) {
  const { t } = useTranslation()
  const [open, setOpen] = useState(true)

  return (
    <>
      <Divider marginY="nano" />
      <Expander open={open} setOpen={setOpen}>
        <ExpanderHeader>
          <H5>{t('odm.proxy', 'Proxy / Heir')}</H5>
        </ExpanderHeader>
        <ExpanderContent>
          <Divider marginY="nano" />
          {proxies && proxies.length > 0 && (
            <DataTable
              columns={[
                { label: t('odm.proxy.type', 'Type of Proxy'), size: 'sm' },
                { label: t('givenName', 'Given Name'), size: 'lg' },
                { label: t('name.parts.surname', 'Surname'), size: 'lg' },
                { label: t('odm.proxy.relation', 'Relation'), size: 'sm' },
              ]}
            >
              {proxies.map((proxy) => {
                return (
                  <DataTableRow
                    key={proxy.id}
                    column1={proxy.type}
                    column2={proxy.givenName}
                    column3={proxy.surName}
                    column4={proxy.relation}
                  />
                )
              })}
            </DataTable>
          )}
          {!proxies || (proxies.length <= 0 && <p>{t('odm.noProxies', 'No Proxies Or Heirs')}</p>)}
          <Divider marginY="nano" />
        </ExpanderContent>
      </Expander>
    </>
  )
}
